import browserDetect from 'browser-detect'
import { capitalize } from 'lodash-es'

export const getBrowser = () => {
  const browser = browserDetect()
  return { ...browser, prettyName: capitalize(browser.name) }
}
